export const styleMap = {
  'margin': (arg) => {
    let str = ``
    // console.log('styleMap-margin',arg)
    arg.map((d) => (str += d + 'px '))
    return { key: 'margin', value: str }
  },
  'padding': (arg) => {
    let str = ``
    arg.map((d) => (str += d + 'px '))
    // console.log('padding-str', str)
    return { key: 'padding', value: str }
  },

  'fontSize': (arg) => {
    return { key: 'font-size', value: arg + 'px' }
  },
  'fontWeight': (arg) => {
    // console.log('fontWeight', arg)
    let str = `300`
    if (arg == 2) str = `bold`
    return { key: 'fontWeight', value: str }
  },
  'backgroundImg': (arg) => {
    const { showType, url } = arg
    // console.log('backgroundImg', showType,url)

    let str = `url(${url})`,
      value = {
        key: 'background-image',
        value: str
      },
      type = 'merge'
    if (!url)
      return {
        value,
        type
      }
    if (showType == 2) {
      str += ' no-repeat'
      value = { type, value: { 'background-image': str, 'background-size': '100% 100%' } }
    }
    if (showType == 'bottom') {
      value = {
        type,
        value: {
          'background-image': str,
          'background-position': 'bottom',
          'background-repeat': 'no-repeat'
        }
      }
    }
    if (showType == 'top') {
      value = {
        type,
        value: {
          'background-image': str,
          'background-position': 'top',
          'background-repeat': 'no-repeat'
        }
      }
    }
    if (showType == 'all') {
      value = {
        type,
        value: {
          'background-image': str,
          'background-size': '100% 100%',
          'background-repeat': 'no-repeat'
        }
      }
    }
    if (showType == 'autoHeight') {
      value = {
        type,
        value: {
          'background-image': str,
          'background-size': 'contain',
          'background-repeat': 'no-repeat'
        }
      }
    }
    if (showType == 'full-width') {
      value = {
        type,
        value: {
          'background-image': str,
          'background-size': '100%',
          'background-repeat': 'no-repeat'
        }
      }
    }
    return value
  },
  'backgroundColor': 'background-color',
  'color': 'color',
  // 'itemBackground': 'background-color',
  // 'itemBorderColor': (arg) => {
  //   // console.log('fontWeight',arg)
  //   return { key: 'border', value: `1px solid ${arg}` }
  // },

  // 'itemBottomLineColor': (arg) => {
  //   // console.log('fontWeight',arg)
  //   return { key: 'border-bottom', value: `1px solid ${arg}` }
  // },
  'itemColor': '',
  'itemFontSize': (arg) => {
    return { key: 'font-size', value: arg + 'px' }
  },
  'itemFontWeight': (arg) => {
    // console.log('fontWeight', arg)
    let str = `300`
    if (arg == 2) str = `bold`
    return { key: 'fontWeight', value: str }
  },
  'itemLayout': '',
  'inputStyle':'',
  'itemMargin': '',
  'itemPadding': '',
  'formItemColor':'color',
  'buttonColor':'color',
  'buttonBackgroundColor':'backgroundColor',
  'formItemMargin':'margin',
  'formBackgroundColor':'background-color',
  'formBackgroundImg':'backgroundImg',
  'itemTitleToCmpDistance': 'margin-bottom',
  'flexBtn': (arg) => {
    let value = null
    if (arg == 2) {
      value = {
        'position': 'fixed',
        'bottom': '100px',
        'width': '365px',
        'z-index': '99'
      }
    }
    return { type: 'merge', value }
  },
  'borderRadius': (arg) => {
    return { key: 'border-radius', value: arg + 'px' }
  }
}
